import { QuestionStatus } from '@exam-management/graphql';
import { Flex, SectionTitle } from '@shared/components';

import { EDITABLE_QUESTION_DETAILS_STATUSES } from '../../constants';
import { DetailFormSection } from '../detail-form-section';
import { DetailView } from '../detail-view';

interface DetailSectionProps {
  questionId?: string;
  readonly?: boolean;
  questionStatus?: QuestionStatus;
}

export default function DetailSection(props: Readonly<DetailSectionProps>) {
  const { questionId, readonly: isReadonly = false, questionStatus = QuestionStatus.Draft } = props;

  const isEditable = EDITABLE_QUESTION_DETAILS_STATUSES.includes(questionStatus) && !isReadonly;

  return (
    <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(4) }}>
      <SectionTitle title='Question' />
      {isEditable ? <DetailFormSection questionId={questionId} /> : <DetailView />}
    </Flex>
  );
}
